import React from 'react'; 
import PropTypes from 'prop-types';

import SectionHeader from '../../../Basic/SectionHeader';
import CheckBox from '../../../Basic/CheckBox';
import DoubleEmail, { DoubleEmailValidation } from '../../DoubleEmail';

class ProjectNotificationsEmail extends React.Component {
    render() {
        const p = this.props;
        const lookup = window.osa.lookup.customerDetails.projectNotificationsEmail;
        let doubleEmail = (p.isSame && !p.retries) ? null : <DoubleEmail name={p.name} required />;
        return (
            <div >
                <SectionHeader title={lookup.title} />
                {p.retries ? null : <CheckBox name={p.name + "_IsSame"} title="Same as above" />}
                <div className="row">
                    <div className="col-sm-4">
                        {doubleEmail}
                    </div>
                </div>
            </div>);
    }
}

ProjectNotificationsEmail.propTypes = {
    name: PropTypes.string.isRequired,
    isSame: PropTypes.number,
    retries: PropTypes.number
};

export default ProjectNotificationsEmail;

export function ProjectNotificationsEmailValidation(name, isSame) {
    if (isSame != "1")
        return [...DoubleEmailValidation(name)];
    else
        return [];
}